export const forCastCard = {
  display: 'flex',
  flexDirection: 'column',
  padding: '6px',
  padding: '15px',
  background: '#F8F8F8',
  boxShadow: 'none',
  borderRadius: '5px',
  height: '100%',
};
export const centerContent = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
};
export const postCntl = {
  position: 'relative',
  bottom: '7px',
};
export const predValue = {
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '1.5em',
};
